import axios from 'axios';
import ls from 'local-storage';
import { is404ResponseStatus } from 'utils/responseStatus';

import { API_ENDPOINT } from './constants';
import TrackingAPI from './TrackingAPI';

const DialogsAPI = {
  async getGuestParams() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/v1/marketing/guest-params`, {})).data;
      return pld;
    } catch (exc) { }
  },

  async getLazyQuestParams() {
    const key = `getLazyQuestParams2`;
    const cachedValue = ls.get(key);
    if (cachedValue == undefined) {
      try {
        const pld = (await axios.get(`${API_ENDPOINT}/v1/marketing/guest-params`, {})).data;
        ls.set(key, pld);
        return pld;
      } catch (exc) { }
    } else {
      return cachedValue;
    }
  },

  async getBatchesNumber() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/v1/marketing/batches-number`, {})).data;
      const totalBatchesNumber = pld?.n || 0;
      const customDialogsUserBatchesNumber = pld?.customDialogsUserBatches || 0;

      return {
        totalBatchesNumber,
        customDialogsUserBatchesNumber
      };
    } catch (exc) { }

    return {
      totalBatchesNumber: 0,
      customDialogsUserBatchesNumber: 0
    };
  },

  async getDialogLimits() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/v1/marketing/batches-number`, {})).data;
      return pld?.limits || {};
    } catch (exc) { }
    return {};
  },

  async getDialogsBatchesStats() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/dialogs-batches-stats`, {})).data;
      return pld;
    } catch (exc) { }
  },

  async getDialogsUsersStats() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/users-dialogs-stats`, {})).data;
      return pld;
    } catch (exc) { }
  },

  async createDialog(scenarioId, userId) {
    try {
      const pld = (
        await axios.post(`${API_ENDPOINT}/dialogs`, {
          scenarioId: scenarioId
        })
      ).data;
      return pld;
    } catch (exc) { }
  },

  async getDialogSuggestions(dialogId, userId) {
    try {
      const pld = (
        await axios.post(
          `${API_ENDPOINT}/dialogs/${dialogId}/suggestions`,
          { userId },
          { timeout: 30 * 1000 }
        )
      ).data;

      return pld;
    } catch (exc) {
      throw 'exception';
    }
  },

  async getDialogSuggestionsMulti(dialogId, userId) {
    try {
      const pld = (
        await axios.post(
          `${API_ENDPOINT}/dialogs/${dialogId}/suggestions/multi`,
          { userId },
          { timeout: 30 * 1000 }
        )
      ).data;

      return pld;
    } catch (exc) {
      throw 'exception';
    }
  },

  async continueDialog(id, userMessage) {
    // try {
    const pld = (
      await axios.post(
        `${API_ENDPOINT}/dialogs/${id}/continue`,
        {
          userMessage: userMessage
        },
        {
          timeout: 30 * 1000
        }
      )
    ).data;

    if (ls('first_message_tracked') == undefined) {
      ls('first_message_tracked', true);
      TrackingAPI.trackEvent('first_message');
    }

    return pld;
    // } catch (exc) {
    //     throw 'exception';
    // }
  },

  async deleteBatch(id, batchIndex) {
    try {
      const pld = (await axios.post(`${API_ENDPOINT}/dialogs/${id}/delete-batch/${batchIndex}`, {}))
        .data;
      return pld;
    } catch (exc) { }
  },

  async regenerateLastDialogBatch(id) {
    try {
      const pld = (await axios.post(`${API_ENDPOINT}/dialogs/${id}/regenerate-last-batch`, {}))
        .data;
      return pld;
    } catch (exc) { }
  },

  async getDialog(id) {
    try {
      const pld = (
        await axios.get(`${API_ENDPOINT}/dialogs/${id}`, {
          params: {}
        })
      ).data;
      return pld;
    } catch (exc) { }
  },

  async getDialogByScenarioAlias(alias, scenarioId, characterName, isAdminPanel = false) {
    try {
      const pld = (
        await axios.get(`${API_ENDPOINT}/dialogs/alias/${alias}`, {
          params: {
            scenarioId: scenarioId,
            characterName: characterName,
            isAdminPanel: isAdminPanel || undefined
          }
        })
      ).data;
      return pld;
    } catch (error) {
      if (is404ResponseStatus(error)) {
        window.location.href = '/';
      }
      throw error;
    }
  },

  async resetDialog(id) {
    try {
      const pld = (await axios.post(`${API_ENDPOINT}/dialogs/${id}/archive`, {})).data;
      return pld;
    } catch (exc) { }
  },

  async deleteDialog(id) {
    try {
      const pld = (await axios.delete(`${API_ENDPOINT}/dialogs/${id}`)).data;
      return pld;
    } catch (exc) { }
  },

  async getModels() {
    try {
      const pld = (
        await axios.get(`${API_ENDPOINT}/models`, {
          params: {}
        })
      ).data;
      return pld;
    } catch (exc) { }
  }
};

export default DialogsAPI;
